import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ManageGroupLayer from "../../../components/Admin/ManageGroupLayer";

const ManageGroup = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageGroupLayer />
      </MasterLayout>
    </>
  );
};

export default ManageGroup;